export var ActionNotifierKey;
(function (ActionNotifierKey) {
    ActionNotifierKey[ActionNotifierKey["SAVE_ACTION"] = 1] = "SAVE_ACTION";
    ActionNotifierKey[ActionNotifierKey["DRAWER_SAVE_ACTION"] = 2] = "DRAWER_SAVE_ACTION";
    ActionNotifierKey[ActionNotifierKey["DO_WORKFLOW_ACTION"] = 3] = "DO_WORKFLOW_ACTION";
    ActionNotifierKey[ActionNotifierKey["CANCEL_ACTION"] = 4] = "CANCEL_ACTION";
    ActionNotifierKey[ActionNotifierKey["TAB_CHANGE_ACTION"] = 5] = "TAB_CHANGE_ACTION";
    ActionNotifierKey[ActionNotifierKey["CLOSE_ACTION"] = 6] = "CLOSE_ACTION";
    ActionNotifierKey[ActionNotifierKey["DRAWER_CLOSE_ACTION"] = 7] = "DRAWER_CLOSE_ACTION";
    ActionNotifierKey[ActionNotifierKey["SUB_FORM_CLOSE_ACTION"] = 8] = "SUB_FORM_CLOSE_ACTION";
    ActionNotifierKey[ActionNotifierKey["SUB_FORM_SAVE_ACTION"] = 9] = "SUB_FORM_SAVE_ACTION";
    ActionNotifierKey[ActionNotifierKey["POST_WORKFLOW_ACTION"] = 10] = "POST_WORKFLOW_ACTION";
})(ActionNotifierKey || (ActionNotifierKey = {}));
//# sourceMappingURL=action-notifier-key.enum.js.map